var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogosFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 71,
    viewBox: "0 0 84 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61_2)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.3594 0H22.6406C13.4503 0 6 7.45026 6 16.6406V54.3594C6 63.5497 13.4503 71 22.6406 71H60.3594C69.5497 71 77 63.5497 77 54.3594V16.6406C77 7.45026 69.5497 0 60.3594 0Z",
    fill: "#F4F2ED"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_61_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 7,
    width: 38,
    height: 57
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.918 7.76562H59.9045V63.2344H22.918V7.76562Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_61_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.1665 63.2344C37.2697 63.2344 41.4112 59.0928 41.4112 53.9897V44.7447H32.1665C27.0634 44.7447 22.9216 48.8865 22.9216 53.9897C22.9216 59.0928 27.0634 63.2344 32.1665 63.2344Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9216 35.5C22.9216 30.3969 27.0634 26.2553 32.1665 26.2553H41.4112V44.7447H32.1665C27.0634 44.7447 22.9216 40.6031 22.9216 35.5Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9211 17.0103C22.9211 11.9072 27.063 7.76562 32.1661 7.76562H41.4108V26.2553H32.1661C27.063 26.2553 22.9211 22.1134 22.9211 17.0103Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4113 7.76562H50.656C55.7591 7.76562 59.9009 11.9072 59.9009 17.0103C59.9009 22.1134 55.7591 26.2553 50.656 26.2553H41.4113V7.76562Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9009 35.5C59.9009 40.6031 55.7591 44.7447 50.656 44.7447C45.5528 44.7447 41.4113 40.6031 41.4113 35.5C41.4113 30.3969 45.5528 26.2553 50.656 26.2553C55.7591 26.2553 59.9009 30.3969 59.9009 35.5Z",
    fill: "#1ABCFE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 71,
    fill: "white",
    transform: "translate(6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosFigma);
export default __webpack_public_path__ + "static/media/logos_figma.51b84561ed0057a8c3552b7393abd15e.svg";
export { ForwardRef as ReactComponent };